import { Alert, Link } from '@/ui'
import { useBreakdownTransparency } from './useBreakdownTransparency'

/**
 * Explains why logged payments are not reducing this quarter's estimate: the
 * calculator credits prior payments only once every earlier quarter has one
 * logged, and always credits them in Q4. Self-gates on the rollout flag so no
 * consumer can surface it early.
 */
export const PaymentGateCallout = ({
  allQuarterPaymentsLogged,
  quarter,
}: {
  allQuarterPaymentsLogged: boolean | undefined
  quarter: string | undefined
}) => {
  const transparencyEnabled = useBreakdownTransparency()

  if (
    !transparencyEnabled ||
    allQuarterPaymentsLogged !== false ||
    quarter === '4'
  ) {
    return null
  }

  return (
    <Alert className="mt-4">
      <div>
        The payments below aren’t credited against this quarter’s estimate yet,
        because an earlier quarter doesn’t have a payment logged. Log every
        earlier quarter to apply them now — otherwise they’ll be credited in Q4.{' '}
        <Link href="/taxes/quarterly?tab=payment_history">
          Enter your past payments
        </Link>
      </div>
    </Alert>
  )
}
